import { Injectable, inject } from '@angular/core';
import { SupabaseService } from '../../../shared/services/supabase.service';
import { OrgId, type UserId } from '../shared/ids';
import { SessionRepository } from './session-repository';

type MemberOrgRow = { org_id: string };

@Injectable()
export class SupabaseSessionRepository extends SessionRepository {
  // Not AuthStore: the client comes from SupabaseService, so the adapter adds no auth.store edge.
  private readonly supabase = inject(SupabaseService);

  async memberOrgIds(userId: UserId): Promise<readonly OrgId[]> {
    const { data, error } = await this.supabase.client
      .from('portal_org_member')
      .select('org_id')
      .eq('user_id', userId)
      .order('joined_at', { ascending: true, nullsFirst: false })
      .order('org_id', { ascending: true });
    if (error) throw error;
    return (data as MemberOrgRow[]).map(rowToOrgId);
  }
}

function rowToOrgId(row: MemberOrgRow): OrgId {
  return OrgId(row.org_id);
}
